import React, { useState, useEffect } from "react";
import { useSession } from "next-auth/client";
import {
    Text, Center, Box, Button, useColorModeValue,
    Flex,
    useDisclosure,
    List,
    ListItem,
    ListIcon,
    OrderedList,
    UnorderedList,
    Link,
} from "@chakra-ui/react";
import { ConfirmPopup } from "components/popups/confirmPopup";
import * as analytics from "utils/analytics";
import CSVReader from "react-csv-reader";
import { firebaseClient } from "firebaseClient";
import { TweetContext } from "context/tweetContext";
import toast from "react-hot-toast";
import { v4 as uuidv4 } from 'uuid';
import { uploadOnS3, getImageSize } from "utils/uploadUtils";
import shortid from 'shortid';
import { getAccount } from "utils/sessionHelper";

const BUCKET_NAME = process.env.NEXT_PUBLIC_PROJECT_BUCKET;

export function CsvUpload({ }) {

    const [isLoading, setIsLoading] = useState(false);
    const { isOpen: isOpenUpload, onOpen: onOpenUpload, onClose: onCloseUpload } = useDisclosure();
    const tweetContext: any = React.useContext(TweetContext);
    const [session, loading] = useSession();

    const handleUpload = async (data, fileInfo) => {

        const db = firebaseClient.firestore();
        analytics.log("upload_tweets_csv", { nbTweets: data?.length });

        // console.log(data, fileInfo);
        setIsLoading(true);
        for await (let row of data) {
            try {
                console.log(row);

                if (!row.text)
                    throw new Error("Tweet text is missing");

                if (row.images) {

                    let images = row.images.split(",");
                    for await (let image of images) {
                        image = image.trim();
                        let name = shortid.generate();

                        let rawImage = await fetch(image);
                        let buffer = await rawImage.arrayBuffer();

                        if (!BUCKET_NAME) {
                            throw new Error("Bucket name not configured");
                        }

                        const file = new File([buffer], name, { type: 'image/jpeg' });
                        let url = await uploadOnS3(file, BUCKET_NAME, "userUpload/" + name);
                        row.text += " [img:" + name + "]";
                    }
                }

                let newId = uuidv4();
                await tweetContext.createDraft({ text: row.text, idAccount: getAccount(session)?.idAccount }, newId);

                toast.success("draft created");
            }
            catch (e) {
                toast.error("Invalid tweet format: " + e.message);
            }
        }

        tweetContext.refresher({});
        setIsLoading(false);
    }

    const papaparseOptions = {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
    };

    return (
        <Box>
            <Button variant={"secondary"} onClick={onOpenUpload}>
                Upload from CSV
            </Button>
            <ConfirmPopup isOpen={isOpenUpload} onClose={onCloseUpload}
                title="Upload tweets with a CSV file"
                body={
                    <Flex flexDir="column">
                        <Text>You have a CSV file with a bunch of tweets?</Text>
                        <Text mt={5}>Use those field as headers:</Text>
                        <UnorderedList pl={2}>
                            <ListItem>text</ListItem>
                        </UnorderedList>
                        <Text mt={5}>Or <Link textDecoration="underline" href="/tweethunter_example_csv.csv" target="_blank">download our example CSV file</Link></Text>
                        <Box mt={5}>
                            <CSVReader
                                // cssClass="react-csv-input"
                                // inputStyle={{ borderRadius: "8px", color: "black" }}
                                onFileLoaded={handleUpload}
                                parserOptions={papaparseOptions}
                            />
                        </Box>
                    </Flex>
                }
                cta={"Done"}
                allowClickBackground={true}
                callback={async () => {
                    onCloseUpload();
                }}
                forceIsLoading={isLoading}
            />
        </Box>
    );
}
